<template>
  <div>
    <a v-b-modal.modal-1>Privacy Statement</a>

    <b-modal id="modal-1" size="xl" title="Privacy Policy">
      <appPrivacyPolicy></appPrivacyPolicy>
    </b-modal>
  </div>
</template>
<script>
import appPrivacyPolicy from '../../views/Common/PrivacyPolicy.vue'
export default {
  components: {
    appPrivacyPolicy
  }
}
</script>